import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PainPointsSection } from './components/PainPointsSection';
import { TomosSection } from './components/TomosSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { MasterPackSection } from './components/MasterPackSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostComparisonSection } from './components/CostComparisonSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
export function App() {
  const testimonials1 = [{
    initials: 'MG',
    quote: 'En tres semanas mi hijo empezó a nombrar lo que siente en lugar de explotar. No lo puedo creer. Este material hace lo que mil conversaciones no lograron.',
    name: 'María G.',
    location: 'Bogotá',
    role: 'Mamá de adolescente de 14 años'
  }, {
    initials: 'LP',
    quote: 'Lo usé en el aula y el cambio fue inmediato. Los chicos por fin tienen palabras para lo que les pasa. El Tomo del Volcán es el favorito de todos.',
    name: 'Laura P.',
    location: 'Buenos Aires',
    role: 'Docente de secundaria'
  }, {
    initials: 'RM',
    quote: 'Mi hija de 16 años lo abrió sola. Sola. Y me pidió que lo hiciéramos juntas. Eso no tenía precio.',
    name: 'Rosa M.',
    location: 'Santiago de Chile',
    role: 'Mamá de adolescente'
  }];
  const testimonials2 = [{
    initials: 'CR',
    quote: 'El Token System cambió la dinámica de casa completamente. Mi hijo hace los ejercicios solo porque quiere ganar tokens. Nunca pensé que iba a funcionar tan rápido.',
    name: 'Cecilia R.',
    location: 'Mendoza',
    role: 'MegaPack + Master-Pack',
    highlight: 'MegaPack + Master-Pack'
  }, {
    initials: 'RM',
    quote: 'Las Cartas de Conexión las uso al inicio de clase. En dos semanas el grupo habla de emociones como si siempre lo hubieran hecho. Es increíble.',
    name: 'Roberto M.',
    location: 'Buenos Aires',
    role: 'Docente de secundaria'
  }, {
    initials: 'SC',
    quote: 'Mi hija de 15 completó el Tomo 1 sola en una semana. Después me pidió que lo hiciéramos juntas desde el principio. Lloramos juntas en varios ejercicios. Vale cada peso.',
    name: 'Sofía C.',
    location: 'Santiago',
    role: 'Mamá de dos adolescentes'
  }, {
    initials: 'PA',
    quote: 'Lo recomiendo a todas las familias de mis pacientes adolescentes. Es el puente entre la consulta y el hogar que siempre necesité.',
    name: 'Pablo A.',
    location: 'Medellín',
    role: 'Psicólogo escolar'
  }];
  return <div className="min-h-screen bg-navy-900 text-slate-200 font-inter selection:bg-blue-500/30 overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <StatsBar data-id="element-2" />

      <TestimonialsSection title="Lo que dicen quienes ya lo tienen" testimonials={testimonials1} data-id="element-3" />

      <PainPointsSection data-id="element-4" />
      <TomosSection data-id="element-5" />
      <BonusesSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <MasterPackSection data-id="element-8" />

      <TestimonialsSection title="❤️ MÁS FAMILIAS Y DOCENTES QUE YA LO TIENEN" testimonials={testimonials2} darker={true} data-id="element-9" />

      <GuaranteeSection data-id="element-10" />
      <FaqSection data-id="element-11" />
      <CostComparisonSection data-id="element-12" />
      <FinalCtaSection data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}